{
  "A0-19" : "O0-19",
  "BIHAV" : "VLIBIN1W",
  "D4314" : "O4314",
  "D4328" : "O4328",
  "D4329" : "O4329",
  "D4869" : "O4869",
  "D4870" : "O4870",
  "D4871" : "O4871",
  "D4872" : "O4872",
  "D4873" : "O4873",
  "D4878" : "O4878",
  "D4881" : "O4881",
  "D4884" : "O4884",
  "D4885" : "O4885",
  "D4889" : "O4889",
  "D4890" : "O4890",
  "D4891" : "O4891",
  "D4892" : "O4892",
  "D4894" : "O4894",
  "D4895" : "O4895",
  "D5017" : "O5017",
  "D511" : "O511",
  "D5596" : "O5596",
  "D563" : "O563",
  "D569" : "O569",
  "D596" : "O596",
  "D601" : "O601",
  "D608" : "O608",
  "D626" : "O626",
  "D6612" : "O6812",
  "D6773" : "O6773",
  "D6774" : "O6774",
  "D6775" : "O6775",
  "D6776" : "O6776",
  "D6778" : "O6778",
  "D6779" : "O6779",
  "D6780" : "O6780",
  "D6781" : "O6781",
  "D6782" : "O6782",
  "D6783" : "O6783",
  "D6784" : "O6784",
  "D6786" : "O6786",
  "D6787" : "O6787",
  "D6788" : "O6788",
  "D6789" : "O6789",
  "D6790" : "O6790",
  "D6791" : "O6791",
  "D6792" : "O6792",
  "D6793" : "O6793",
  "D6794" : "O6794",
  "D6795" : "O6795",
  "D6809" : "O6809",
  "D6811" : "O6811",
  "D6815" : "O6815",
  "D6819" : "O6819",
  "D6820" : "O6820",
  "D6821" : "O6821",
  "D6823" : "O6823",
  "D6825" : "O6825",
  "D6828" : "O6828",
  "D6829" : "O6829",
  "D6831" : "O6831",
  "D6832" : "O6832",
  "D6833" : "O6833",
  "D684" : "O684",
  "D6841" : "O6841",
  "D6842" : "O6842",
  "D6848" : "O6848",
  "D6850" : "O6850",
  "D6852" : "O6852",
  "D6854" : "O6854",
  "D6857" : "O6857",
  "D6858" : "O6858",
  "D6859" : "O6859",
  "D6860" : "O6860",
  "D6862" : "O6862",
  "D6863" : "O6863",
  "D6864" : "O6864",
  "D6865" : "O6865",
  "D6866" : "O6866",
  "D744" : "O744",
  "D782" : "O782",
  "D796" : "O796",
  "D797" : "O797",
  "D798" : "O798",
  "D799" : "O799",
  "D809" : "O809",
  "D811" : "O811",
  "D813" : "O813",
  "D815" : "O815",
  "D820" : "O820",
  "D831" : "O831",
  "D834" : "O834",
  "D837" : "O837",
  "D839" : "O839",
  "D841" : "O841",
  "D848" : "O848",
  "D861" : "O861",
  "D894" : "O894",
  "D928" : "O928",
  "D9512" : "O9512",
  "D9649" : "O9649",
  "D9677" : "O9677",
  "D9734" : "O9734",
  "D9735" : "O9735",
  "D9736" : "O9736",
  "D978" : "O978",
  "D9834" : "O9834",
  "M122" : "O122",
  "M124" : "O124",
  "M128" : "O128",
  "M133" : "O133",
  "M154" : "O154",
  "M164" : "O164",
  "M171" : "O171",
  "M178" : "O178",
  "M183" : "O183",
  "M187" : "O187",
  "M188" : "O188",
  "M190" : "O190",
  "M225" : "O225",
  "M226" : "O226",
  "M230" : "O230",
  "M239" : "O239",
  "M247" : "O247",
  "M307" : "O307",
  "M331" : "O331",
  "M373" : "O373",
  "M380" : "O380",
  "M412" : "O412",
  "M4254" : "O4254",
  "M4255" : "O4255",
  "M4259" : "O4259",
  "M4319" : "O4319",
  "M4320" : "O4320",
  "M4330" : "O4330",
  "M4340" : "O4340",
  "M4341" : "O4341",
  "M4342" : "O4342",
  "M4343" : "O4343",
  "M4436" : "O4436",
  "M4469" : "O4469",
  "M493" : "O493",
  "M4930" : "O4930",
  "M4934" : "O4934",
  "M4938" : "O4938",
  "M4939" : "O4939",
  "M494" : "O494",
  "M5625" : "O5625",
  "M73" : "O73",
  "M75" : "O75",
  "M81" : "O81",
  "M8101" : "O8101",
  "M819" : "O819",
  "M859" : "O859",
  "M862" : "O862",
  "M875" : "O875",
  "M91" : "O91",
  "M916" : "O916",
  "M922" : "O922",
  "M930" : "O930",
  "M947" : "O947",
  "M9515" : "O9515",
  "M9608" : "O9608",
  "M9622" : "O9622",
  "M9623" : "O9623",
  "M9624" : "O9624",
  "M9625" : "O9625",
  "M9626" : "O9626",
  "M9627" : "O9627",
  "M9628" : "O9628",
  "M968" : "O968",
  "M9682" : "O9682",
  "M9683" : "O9683",
  "M9724" : "O9724",
  "M9728" : "O9728",
  "M9729" : "O9729",
  "M9767" : "O9767",
  "M9768" : "O9768",
  "M9799" : "O9799",
  "M9809" : "O9809",
  "M9824" : "O9824",
  "M9841" : "O9841",
  "M9860" : "O9860",
  "R1000" : "G1000",
  "R1001" : "G1001",
  "R1002" : "G1002",
  "R1003" : "G1003",
  "R1004" : "G1004",
  "R1005" : "G1005",
  "R1011" : "G1011",
  "R1012" : "G1012",
  "R1013" : "G1013",
  "R1014" : "G1014",
  "R1015" : "G1015",
  "R1016" : "G1016",
  "R1017" : "G1017",
  "R1022" : "G1022",
  "R1023" : "G1023",
  "R1024" : "G1024",
  "R1025" : "G1025",
  "R1027" : "G1027",
  "R1030" : "G1030",
  "R1031" : "G1031",
  "R1047" : "G1047",
  "R1100" : "G1100",
  "R1115" : "G1115",
  "R1117" : "G1117",
  "R1118" : "G1118",
  "R1119" : "G1119",
  "R1120" : "G1120",
  "R1128" : "G1128",
  "R1129" : "G1129",
  "R1130" : "G1130",
  "R1131" : "G1131",
  "R1132" : "G1132",
  "R1133" : "G1133",
  "R114" : "G114",
  "R1147" : "G1147",
  "R115" : "G115",
  "R1151" : "G1151",
  "R1152" : "G1152",
  "R116" : "G116",
  "R1162" : "G1162",
  "R1163" : "G1163",
  "R1169" : "G1169",
  "R1170" : "G1170",
  "R1173" : "G1173",
  "R1174" : "G1174",
  "R1175" : "G1175",
  "R1176" : "G1176",
  "R1177" : "G1177",
  "R1178" : "G1178",
  "R1210" : "G1210",
  "R1212" : "G1212",
  "R1213" : "G1213",
  "R1214" : "G1214",
  "R1215" : "G1215",
  "R1236" : "G1236",
  "R1237" : "G1237",
  "R1238" : "G1238",
  "R1239" : "G1239",
  "R1240" : "G1240",
  "R1241" : "G1241",
  "R1243" : "G1243",
  "R1244" : "G1244",
  "R1245" : "G1245",
  "R1246" : "G1246",
  "R1247" : "G1247",
  "R1248" : "G1248",
  "R1249" : "G1249",
  "R1250" : "G1250",
  "R1251" : "G1251",
  "R1252" : "G1252",
  "R1253" : "G1253",
  "R1254" : "G1254",
  "R1255" : "G1255",
  "R1256" : "G1256",
  "R1274" : "G1274",
  "R1275" : "G1275",
  "R1276" : "G1276",
  "R1277" : "G1277",
  "R1278" : "G1278",
  "R1279" : "G1279",
  "R128" : "G128",
  "R1280" : "G1280",
  "R1281" : "G1281",
  "R1282" : "G1282",
  "R1283" : "G1283",
  "R1291" : "G1291",
  "R1292" : "G1292",
  "R1295" : "G1295",
  "R1296" : "G1296",
  "R1297" : "G1297",
  "R1298" : "G1298",
  "R1299" : "G1299",
  "R13" : "G13",
  "R1300" : "G1300",
  "R1301" : "G1301",
  "R1302" : "G1302",
  "R1303" : "G1303",
  "R1304" : "G1304",
  "R1305" : "G1305",
  "R1306" : "G1306",
  "R1307" : "G1307",
  "R1308" : "G1308",
  "R1309" : "G1309",
  "R1310" : "G1310",
  "R1311" : "G1311",
  "R1312" : "G1312",
  "R1313" : "G1313",
  "R1314" : "G1314",
  "R1315" : "G1315",
  "R1316" : "G1316",
  "R1317" : "G1317",
  "R1319" : "G1319",
  "R1350" : "G1350",
  "R1351" : "G1351",
  "R1352" : "G1352",
  "R1359" : "G1359",
  "R1360" : "G1360",
  "R1361" : "G1361",
  "R1362" : "G1362",
  "R1363" : "G1363",
  "R1364" : "G1364",
  "R1365" : "G1365",
  "R1366" : "G1366",
  "R1367" : "G1367",
  "R1368" : "G1368",
  "R1369" : "G1369",
  "R1370" : "G1370",
  "R1371" : "G1371",
  "R14" : "G14",
  "R15" : "G15",
  "R153" : "G153",
  "R154" : "G154",
  "R16" : "G16",
  "R165" : "G165",
  "R166" : "G166",
  "R167" : "G167",
  "R168" : "G168",
  "R169" : "G169",
  "R17" : "G17",
  "R170" : "G170",
  "R171" : "G171",
  "R172" : "G172",
  "R173" : "G173",
  "R174" : "G174",
  "R175" : "G175",
  "R176" : "G176",
  "R177" : "G177",
  "R178" : "G178",
  "R179" : "G179",
  "R180" : "G180",
  "R181" : "G181",
  "R182" : "G182",
  "R183" : "G183",
  "R184" : "G184",
  "R185" : "G185",
  "R186" : "G186",
  "R187" : "G187",
  "R188" : "G188",
  "R189" : "G189",
  "R190" : "G190",
  "R191" : "G191",
  "R192" : "G192",
  "R193" : "G193",
  "R194" : "G194",
  "R195" : "G195",
  "R196" : "G196",
  "R198" : "G198",
  "R20" : "G20",
  "R21" : "G21",
  "R210" : "G210",
  "R2103" : "G2103",
  "R2104" : "G2104",
  "R2105" : "G2105",
  "R2106" : "G2106",
  "R2107" : "G2107",
  "R2108" : "G2108",
  "R2109" : "G2109",
  "R2110" : "G2110",
  "R2111" : "G2111",
  "R2112" : "G2112",
  "R2114" : "G2114",
  "R2115" : "G2115",
  "R2116" : "G2116",
  "R2117" : "G2117",
  "R2118" : "G2118",
  "R2119" : "G2119",
  "R2121" : "G2121",
  "R2124" : "G2124",
  "R2125" : "G2125",
  "R2126" : "G2126",
  "R2127" : "G2127",
  "R2128" : "G2128",
  "R2129" : "G2129",
  "R2130" : "G2130",
  "R2140" : "G2140",
  "R2141" : "G2141",
  "R2142" : "G2142",
  "R2143" : "G2143",
  "R2144" : "G2144",
  "R2145" : "G2145",
  "R2146" : "G2146",
  "R2147" : "G2147",
  "R2148" : "G2148",
  "R2149" : "G2149",
  "R2152" : "G2152",
  "R2153" : "G2153",
  "R2154" : "G2154",
  "R2155" : "G2155",
  "R2156" : "G2156",
  "R2157" : "G2157",
  "R2158" : "G2158",
  "R2159" : "G2159",
  "R2160" : "G2160",
  "R2161" : "G2161",
  "R2162" : "G2162",
  "R2163" : "G2163",
  "R2164" : "G2164",
  "R2165" : "G2165",
  "R2166" : "G2166",
  "R2167" : "G2167",
  "R2168" : "G2168",
  "R217" : "G217",
  "R2170" : "G2170",
  "R2171" : "G2171",
  "R2172" : "G2172",
  "R2173" : "G2173",
  "R2174" : "G2174",
  "R2175" : "G2175",
  "R2176" : "G2176",
  "R2177" : "G2177",
  "R2178" : "G2178",
  "R2179" : "G2179",
  "R218" : "G218",
  "R2180" : "G2180",
  "R2181" : "G2181",
  "R2182" : "G2182",
  "R2183" : "G2183",
  "R2184" : "G2184",
  "R2185" : "G2185",
  "R2186" : "G2186",
  "R2187" : "G2187",
  "R2188" : "G2188",
  "R2189" : "G2189",
  "R219" : "G219",
  "R2190" : "G2190",
  "R2191" : "G2191",
  "R2192" : "G2192",
  "R2193" : "G2193",
  "R2194" : "G2194",
  "R2195" : "G2195",
  "R2196" : "G2196",
  "R2197" : "G2197",
  "R2198" : "G2198",
  "R2199" : "G2199",
  "R220" : "G220",
  "R2200" : "G2200",
  "R2201" : "G2201",
  "R2202" : "G2202",
  "R2203" : "G2203",
  "R2204" : "G2204",
  "R2205" : "G2205",
  "R2206" : "G2206",
  "R2207" : "G2207",
  "R2208" : "G2208",
  "R2209" : "G2209",
  "R221" : "G221",
  "R2210" : "G2210",
  "R2211" : "G2211",
  "R2212" : "G2212",
  "R2213" : "G2213",
  "R2214" : "G2214",
  "R2215" : "G2215",
  "R2216" : "G2216",
  "R2218" : "G2218",
  "R2219" : "G2219",
  "R222" : "G222",
  "R2220" : "G2220",
  "R2221" : "G2221",
  "R2222" : "G2222",
  "R2223" : "G2223",
  "R2224" : "G2224",
  "R2225" : "G2225",
  "R2226" : "G2226",
  "R2227" : "G2227",
  "R2228" : "G2228",
  "R2229" : "G2229",
  "R223" : "G223",
  "R2230" : "G2230",
  "R2231" : "G2231",
  "R2232" : "G2232",
  "R2233" : "G2233",
  "R224" : "G224",
  "R2242" : "G2242",
  "R2243" : "G2243",
  "R2244" : "G2244",
  "R2245" : "G2245",
  "R225" : "G225",
  "R226" : "G226",
  "R227" : "G227",
  "R228" : "G228",
  "R229" : "G229",
  "R23" : "G23",
  "R230" : "G230",
  "R231" : "G231",
  "R232" : "G232",
  "R233" : "G233",
  "R234" : "G234",
  "R235" : "G235",
  "R236" : "G236",
  "R237" : "G237",
  "R238" : "G238",
  "R239" : "G239",
  "R24" : "G24",
  "R240" : "G240",
  "R241" : "G241",
  "R242" : "G242",
  "R243" : "G243",
  "R244" : "G244",
  "R245" : "G245",
  "R246" : "G246",
  "R25" : "G25",
  "R2500" : "G2500",
  "R2501" : "G2501",
  "R2503" : "G2503",
  "R2504" : "G2504",
  "R2509" : "G2509",
  "R2510" : "G2510",
  "R2511" : "G2511",
  "R2512" : "G2512",
  "R2513" : "G2513",
  "R2514" : "G2514",
  "R2515" : "G2515",
  "R2517" : "G2517",
  "R2518" : "G2518",
  "R2519" : "G2519",
  "R2520" : "G2520",
  "R2521" : "G2521",
  "R2522" : "G2522",
  "R2523" : "G2523",
  "R2524" : "G2524",
  "R2525" : "G2525",
  "R2526" : "G2526",
  "R2530" : "G2530",
  "R2531" : "G2531",
  "R2537" : "G2537",
  "R2538" : "G2538",
  "R2539" : "G2539",
  "R2540" : "G2540",
  "R2541" : "G2541",
  "R2542" : "G2542",
  "R2543" : "G2543",
  "R2544" : "G2544",
  "R2545" : "G2545",
  "R2547" : "G2547",
  "R2548" : "G2548",
  "R2549" : "G2549",
  "R255" : "G255",
  "R2550" : "G2550",
  "R2551" : "G2551",
  "R2552" : "G2552",
  "R2553" : "G2553",
  "R2554" : "G2554",
  "R2567" : "G2567",
  "R2568" : "G2568",
  "R2569" : "G2569",
  "R2570" : "G2570",
  "R2571" : "G2571",
  "R2572" : "G2572",
  "R2573" : "G2573",
  "R2574" : "G2574",
  "R2576" : "G2576",
  "R2577" : "G2577",
  "R2578" : "G2578",
  "R2579" : "G2579",
  "R258" : "G258",
  "R2580" : "G2580",
  "R2581" : "G2581",
  "R2582" : "G2582",
  "R2583" : "G2583",
  "R2586" : "G2586",
  "R2588" : "G2588",
  "R2590" : "G2590",
  "R2591" : "G2591",
  "R2592" : "G2592",
  "R2593" : "G2593",
  "R2594" : "G2594",
  "R2595" : "G2595",
  "R2596" : "G2596",
  "R2597" : "G2597",
  "R2598" : "G2598",
  "R2599" : "G2599",
  "R26" : "G26",
  "R2600" : "G2600",
  "R2601" : "G2601",
  "R2602" : "G2602",
  "R2603" : "G2603",
  "R2605" : "G2605",
  "R2606" : "G2606",
  "R2607" : "G2607",
  "R2608" : "G2608",
  "R2609" : "G2609",
  "R261" : "G261",
  "R2610" : "G2610",
  "R2611" : "G2611",
  "R2612" : "G2612",
  "R2613" : "G2613",
  "R2614" : "G2614",
  "R2615" : "G2615",
  "R2616" : "G2616",
  "R2617" : "G2617",
  "R2618" : "G2618",
  "R2619" : "G2619",
  "R262" : "G262",
  "R2620" : "G2620",
  "R2621" : "G2621",
  "R2622" : "G2622",
  "R2623" : "G2623",
  "R2625" : "G2625",
  "R2626" : "G2626",
  "R2627" : "G2627",
  "R263" : "G263",
  "R2631" : "G2631",
  "R2632" : "G2632",
  "R264" : "G264",
  "R2641" : "G2641",
  "R2642" : "G2642",
  "R2643" : "G2643",
  "R2644" : "G2644",
  "R2645" : "G2645",
  "R2646" : "G2646",
  "R2647" : "G2647",
  "R2648" : "G2648",
  "R2649" : "G2649",
  "R265" : "G265",
  "R2650" : "G2650",
  "R2651" : "G2651",
  "R2654" : "G2654",
  "R2655" : "G2655",
  "R266" : "G266",
  "R2662" : "G2662",
  "R2663" : "G2663",
  "R2664" : "G2664",
  "R2665" : "G2665",
  "R2666" : "G2666",
  "R2667" : "G2667",
  "R2668" : "G2668",
  "R2669" : "G2669",
  "R267" : "G267",
  "R2670" : "G2670",
  "R2671" : "G2671",
  "R2672" : "G2672",
  "R2673" : "G2673",
  "R2674" : "G2674",
  "R2675" : "G2675",
  "R2676" : "G2676",
  "R2677" : "G2677",
  "R2678" : "G2678",
  "R2679" : "G2679",
  "R268" : "G268",
  "R2680" : "G2680",
  "R2681" : "G2681",
  "R2682" : "G2682",
  "R2683" : "G2683",
  "R2684" : "G2684",
  "R2685" : "G2685",
  "R2686" : "G2686",
  "R2687" : "G2687",
  "R2688" : "G2688",
  "R2689" : "G2689",
  "R269" : "G269",
  "R2690" : "G2690",
  "R2691" : "G2691",
  "R2692" : "G2692",
  "R2693" : "G2693",
  "R2694" : "G2694",
  "R2695" : "G2695",
  "R2696" : "G2696",
  "R2697" : "G2697",
  "R2699" : "G2699",
  "R27" : "G27",
  "R270" : "G270",
  "R2701" : "G2701",
  "R2709" : "G2709",
  "R271" : "G271",
  "R2711" : "G2711",
  "R2712" : "G2712",
  "R2713" : "G2713",
  "R2714" : "G2714",
  "R2715" : "G2715",
  "R2716" : "G2716",
  "R2717" : "G2717",
  "R2718" : "G2718",
  "R2719" : "G2719",
  "R272" : "G272",
  "R2720" : "G2720",
  "R2721" : "G2721",
  "R2722" : "G2722",
  "R2723" : "G2723",
  "R2724" : "G2724",
  "R2725" : "G2725",
  "R2726" : "G2726",
  "R2727" : "G2727",
  "R2728" : "G2728",
  "R2729" : "G2729",
  "R273" : "G273",
  "R2730" : "G2730",
  "R2731" : "G2731",
  "R2732" : "G2732",
  "R2733" : "G2733",
  "R2734" : "G2734",
  "R2735" : "G2735",
  "R2736" : "G2736",
  "R2737" : "G2737",
  "R2738" : "G2738",
  "R2739" : "G2739",
  "R274" : "G274",
  "R2740" : "G2740",
  "R2741" : "G2741",
  "R2742" : "G2742",
  "R2744" : "G2744",
  "R275" : "G275",
  "R2753" : "G2753",
  "R2754" : "G2754",
  "R2755" : "G2755",
  "R2756" : "G2756",
  "R2757" : "G2757",
  "R2758" : "G2758",
  "R2759" : "G2759",
  "R276" : "G276",
  "R2760" : "G2760",
  "R2761" : "G2761",
  "R2762" : "G2762",
  "R2763" : "G2763",
  "R2764" : "G2764",
  "R2765" : "G2765",
  "R2780" : "G2780",
  "R2784" : "G2784",
  "R2785" : "G2785",
  "R2786" : "G2786",
  "R2787" : "G2787",
  "R2788" : "G2788",
  "R2789" : "G2789",
  "R2790" : "G2790",
  "R2791" : "G2791",
  "R2792" : "G2792",
  "R2793" : "G2793",
  "R2794" : "G2794",
  "R2795" : "G2795",
  "R2796" : "G2796",
  "R2797" : "G2797",
  "R2798" : "G2798",
  "R2799" : "G2799",
  "R2800" : "G2800",
  "R2801" : "G2801",
  "R2802" : "G2802",
  "R2803" : "G2803",
  "R2804" : "G2804",
  "R2805" : "G2805",
  "R2806" : "G2806",
  "R2807" : "G2807",
  "R2808" : "G2808",
  "R2809" : "G2809",
  "R2810" : "G2810",
  "R2811" : "G2811",
  "R2812" : "G2812",
  "R2813" : "G2813",
  "R2814" : "G2814",
  "R2818" : "G2818",
  "R2819" : "G2819",
  "R2820" : "G2820",
  "R2821" : "G2821",
  "R2822" : "G2822",
  "R2823" : "G2823",
  "R2824" : "G2824",
  "R2825" : "G2825",
  "R2826" : "G2826",
  "R283" : "G283",
  "R284" : "G284",
  "R285" : "G285",
  "R286" : "G286",
  "R287" : "G287",
  "R288" : "G288",
  "R289" : "G289",
  "R29" : "G29",
  "R290" : "G290",
  "R2906" : "G2906",
  "R2907" : "G2907",
  "R2908" : "G2908",
  "R2909" : "G2909",
  "R291" : "G291",
  "R2910" : "G2910",
  "R2911" : "G2911",
  "R2912" : "G2912",
  "R2916" : "G2916",
  "R2917" : "G2917",
  "R292" : "G292",
  "R293" : "G293",
  "R294" : "G294",
  "R295" : "G295",
  "R3007" : "G3007",
  "R3009" : "G3009",
  "R301" : "G301",
  "R3010" : "G3010",
  "R3011" : "G3011",
  "R3012" : "G3012",
  "R3013" : "G3013",
  "R3014" : "G3014",
  "R3015" : "G3015",
  "R3016" : "G3016",
  "R3017" : "G3017",
  "R3018" : "G3018",
  "R3019" : "G3019",
  "R302" : "G302",
  "R3020" : "G3020",
  "R3021" : "G3021",
  "R3022" : "G3022",
  "R3023" : "G3023",
  "R3024" : "G3024",
  "R3025" : "G3025",
  "R3026" : "G3026",
  "R3027" : "G3027",
  "R3028" : "G3028",
  "R3029" : "G3029",
  "R303" : "G303",
  "R3030" : "G3030",
  "R3031" : "G3031",
  "R3032" : "G3032",
  "R3033" : "G3033",
  "R3034" : "G3034",
  "R3035" : "G3035",
  "R3036" : "G3036",
  "R3037" : "G3037",
  "R3038" : "G3038",
  "R3039" : "G3039",
  "R304" : "G304",
  "R3040" : "G3040",
  "R3041" : "G3041",
  "R3042" : "G3042",
  "R305" : "G305",
  "R306" : "G306",
  "R307" : "G307",
  "R308" : "G308",
  "R3100" : "G3100",
  "R3101" : "G3101",
  "R3102" : "G3102",
  "R3103" : "G3103",
  "R3104" : "G3104",
  "R3105" : "G3105",
  "R3106" : "G3106",
  "R3107" : "G3107",
  "R3108" : "G3108",
  "R3109" : "G3109",
  "R3110" : "G3110",
  "R3111" : "G3111",
  "R3112" : "G3112",
  "R3113" : "G3113",
  "R3114" : "G3114",
  "R3115" : "G3115",
  "R3116" : "G3116",
  "R3117" : "G3117",
  "R3118" : "G3118",
  "R3119" : "G3119",
  "R3120" : "G3120",
  "R3121" : "G3121",
  "R3122" : "G3122",
  "R32" : "G32",
  "R3204" : "G3204",
  "R3205" : "G3205",
  "R3206" : "G3206",
  "R3207" : "G3207",
  "R3208" : "G3208",
  "R3209" : "G3209",
  "R3210" : "G3210",
  "R3211" : "G3211",
  "R3212" : "G3212",
  "R3213" : "G3213",
  "R3214" : "G3214",
  "R3215" : "G3215",
  "R3216" : "G3216",
  "R3217" : "G3217",
  "R3218" : "G3218",
  "R3219" : "G3219",
  "R3220" : "G3220",
  "R3221" : "G3221",
  "R3222" : "G3222",
  "R3223" : "G3223",
  "R3224" : "G3224",
  "R3225" : "G3225",
  "R3226" : "G3226",
  "R3227" : "G3227",
  "R3229" : "G3229",
  "R3230" : "G3230",
  "R3231" : "G3231",
  "R3232" : "G3232",
  "R3233" : "G3233",
  "R3234" : "G3234",
  "R3235" : "G3235",
  "R3236" : "G3236",
  "R3237" : "G3237",
  "R3238" : "G3238",
  "R3239" : "G3239",
  "R3240" : "G3240",
  "R3241" : "G3241",
  "R3242" : "G3242",
  "R3243" : "G3243",
  "R3244" : "G3244",
  "R3245" : "G3245",
  "R3246" : "G3246",
  "R3247" : "G3247",
  "R3248" : "G3248",
  "R3249" : "G3249",
  "R3250" : "G3250",
  "R3251" : "G3251",
  "R3252" : "G3252",
  "R3253" : "G3253",
  "R3254" : "G3254",
  "R3255" : "G3255",
  "R3256" : "G3256",
  "R3257" : "G3257",
  "R3258" : "G3258",
  "R3259" : "G3259",
  "R3260" : "G3260",
  "R3261" : "G3261",
  "R3269" : "G3269",
  "R34" : "G34",
  "R342" : "G342",
  "R343" : "G343",
  "R344" : "G344",
  "R345" : "G345",
  "R3450" : "G3450",
  "R346" : "G346",
  "R347" : "G347",
  "R348" : "G348",
  "R349" : "G349",
  "R350" : "G350",
  "R351" : "G351",
  "R352" : "G352",
  "R353" : "G353",
  "R354" : "G354",
  "R355" : "G355",
  "R356" : "G356",
  "R357" : "G357",
  "R358" : "G358",
  "R359" : "G359",
  "R360" : "G360",
  "R361" : "G361",
  "R362" : "G362",
  "R363" : "G363",
  "R364" : "G364",
  "R365" : "G365",
  "R366" : "G366",
  "R367" : "G367",
  "R368" : "G368",
  "R369" : "G369",
  "R370" : "G370",
  "R371" : "G371",
  "R372" : "G372",
  "R373" : "G373",
  "R374" : "G374",
  "R375" : "G375",
  "R376" : "G376",
  "R377" : "G377",
  "R378" : "G378",
  "R379" : "G379",
  "R380" : "G380",
  "R381" : "G381",
  "R382" : "G382",
  "R383" : "G383",
  "R384" : "G384",
  "R385" : "G385",
  "R386" : "G386",
  "R387" : "G387",
  "R4011" : "G4011",
  "R4012" : "G4012",
  "R4017" : "G4017",
  "R4019" : "G4019",
  "R4020" : "G4020",
  "R4024" : "G4024",
  "R4026" : "G4026",
  "R4027" : "G4027",
  "R4028" : "G4028",
  "R4029" : "G4029",
  "R4030" : "G4030",
  "R4031" : "G4031",
  "R4032" : "G4032",
  "R4033" : "G4033",
  "R4035" : "G4035",
  "R4036" : "G4036",
  "R4038" : "G4038",
  "R4039" : "G4039",
  "R4040" : "G4040",
  "R4041" : "G4041",
  "R4042" : "G4042",
  "R4043" : "G4043",
  "R4044" : "G4044",
  "R4045" : "G4045",
  "R4046" : "G4046",
  "R4047" : "G4047",
  "R4048" : "G4048",
  "R4049" : "G4049",
  "R4050" : "G4050",
  "R4051" : "G4051",
  "R4052" : "G4052",
  "R4055" : "G4055",
  "R4056" : "G4056",
  "R4057" : "G4057",
  "R4058" : "G4058",
  "R4059" : "G4059",
  "R4060" : "G4060",
  "R4061" : "G4061",
  "R4062" : "G4062",
  "R4063" : "G4063",
  "R4064" : "G4064",
  "R4065" : "G4065",
  "R4066" : "G4066",
  "R4067" : "G4067",
  "R4068" : "G4068",
  "R4069" : "G4069",
  "R4070" : "G4070",
  "R4071" : "G4071",
  "R4072" : "G4072",
  "R4073" : "G4073",
  "R4074" : "G4074",
  "R4075" : "G4075",
  "R4076" : "G4076",
  "R4077" : "G4077",
  "R4078" : "G4078",
  "R4079" : "G4079",
  "R408" : "G408",
  "R4080" : "G4080",
  "R4081" : "G4081",
  "R4082" : "G4082",
  "R4083" : "G4083",
  "R4084" : "G4084",
  "R4085" : "G4085",
  "R409" : "G409",
  "R410" : "G410",
  "R4100" : "G4100",
  "R4101" : "G4101",
  "R4102" : "G4102",
  "R4103" : "G4103",
  "R4104" : "G4104",
  "R4105" : "G4105",
  "R4106" : "G4106",
  "R4107" : "G4107",
  "R4108" : "G4108",
  "R4109" : "G4109",
  "R411" : "G411",
  "R4110" : "G4110",
  "R4111" : "G4111",
  "R4112" : "G4112",
  "R4113" : "G4113",
  "R4114" : "G4114",
  "R4115" : "G4115",
  "R4116" : "G4116",
  "R4117" : "G4117",
  "R4118" : "G4118",
  "R4119" : "G4119",
  "R412" : "G412",
  "R4120" : "G4120",
  "R4121" : "G4121",
  "R4122" : "G4122",
  "R4123" : "G4123",
  "R4124" : "G4124",
  "R4125" : "G4125",
  "R4126" : "G4126",
  "R4127" : "G4127",
  "R4128" : "G4128",
  "R4129" : "G4129",
  "R413" : "G413",
  "R4130" : "G4130",
  "R4131" : "G4131",
  "R4132" : "G4132",
  "R4133" : "G4133",
  "R4136" : "G4136",
  "R4137" : "G4137",
  "R4138" : "G4138",
  "R4139" : "G4139",
  "R414" : "G414",
  "R4140" : "G4140",
  "R4141" : "G4141",
  "R4142" : "G4142",
  "R4143" : "G4143",
  "R4144" : "G4144",
  "R4145" : "G4145",
  "R4146" : "G4146",
  "R4147" : "G4147",
  "R4149" : "G4149",
  "R415" : "G415",
  "R4150" : "G4150",
  "R4151" : "G4151",
  "R4152" : "G4152",
  "R4153" : "G4153",
  "R4154" : "G4154",
  "R4155" : "G4155",
  "R4156" : "G4156",
  "R4157" : "G4157",
  "R4158" : "G4158",
  "R4159" : "G4159",
  "R416" : "G416",
  "R4160" : "G4160",
  "R4200" : "G4200",
  "R4201" : "G4201",
  "R4202" : "G4202",
  "R4203" : "G4203",
  "R4204" : "G4204",
  "R4205" : "G4205",
  "R4206" : "G4206",
  "R4207" : "G4207",
  "R4208" : "G4208",
  "R4209" : "G4209",
  "R4213" : "G4213",
  "R4214" : "G4214",
  "R4215" : "G4215",
  "R4250" : "G4250",
  "R4251" : "G4251",
  "R4252" : "G4252",
  "R4253" : "G4253",
  "R4254" : "G4254",
  "R4255" : "G4255",
  "R4256" : "G4256",
  "R4257" : "G4257",
  "R4258" : "G4258",
  "R4259" : "G4259",
  "R4260" : "G4260",
  "R4261" : "G4261",
  "R4262" : "G4262",
  "R4263" : "G4263",
  "R4264" : "G4264",
  "R4265" : "G4265",
  "R4266" : "G4266",
  "R4267" : "G4267",
  "R4268" : "G4268",
  "R4300" : "G4300",
  "R4301" : "G4301",
  "R4302" : "G4302",
  "R4303" : "G4303",
  "R4304" : "G4304",
  "R4305" : "G4305",
  "R4306" : "G4306",
  "R4307" : "G4307",
  "R4308" : "G4308",
  "R4309" : "G4309",
  "R4310" : "G4310",
  "R4311" : "G4311",
  "R4312" : "G4312",
  "R4313" : "G4313",
  "R4314" : "G4314",
  "R4315" : "G4315",
  "R4316" : "G4316",
  "R4400" : "G4400",
  "R4401" : "G4401",
  "R4402" : "G4402",
  "R4500" : "G4500",
  "R4501" : "G4501",
  "R4502" : "G4502",
  "R4503" : "G4503",
  "R4504" : "G4504",
  "R4507" : "G4507",
  "R4508" : "G4508",
  "R4509" : "G4509",
  "R4510" : "G4510",
  "R4511" : "G4511",
  "R4512" : "G4512",
  "R4514" : "G4514",
  "R4515" : "G4515",
  "R4516" : "G4516",
  "R4517" : "G4517",
  "R4518" : "G4518",
  "R4519" : "G4519",
  "R4520" : "G4520",
  "R4521" : "G4521",
  "R4522" : "G4522",
  "R4526" : "G4526",
  "R4527" : "G4527",
  "R4528" : "G4528",
  "R4529" : "G4529",
  "R4530" : "G4530",
  "R4531" : "G4531",
  "R4532" : "G4532",
  "R4533" : "G4533",
  "R4534" : "G4534",
  "R4535" : "G4535",
  "R4536" : "G4536",
  "R4537" : "G4537",
  "R4538" : "G4538",
  "R4539" : "G4539",
  "R4540" : "G4540",
  "R4541" : "G4541",
  "R4542" : "G4542",
  "R4543" : "G4543",
  "R4544" : "G4544",
  "R4545" : "G4545",
  "R4546" : "G4546",
  "R4547" : "G4547",
  "R4548" : "G4548",
  "R4549" : "G4549",
  "R4550" : "G4550",
  "R4551" : "G4551",
  "R4552" : "G4552",
  "R4553" : "G4553",
  "R4554" : "G4554",
  "R4555" : "G4555",
  "R4556" : "G4556",
  "R4557" : "G4557",
  "R4558" : "G4558",
  "R4559" : "G4559",
  "R4560" : "G4560",
  "R4561" : "G4561",
  "R4562" : "G4562",
  "R4563" : "G4563",
  "R4564" : "G4564",
  "R4565" : "G4565",
  "R4566" : "G4566",
  "R4567" : "G4567",
  "R4568" : "G4568",
  "R4569" : "G4569",
  "R4570" : "G4570",
  "R4571" : "G4571",
  "R4572" : "G4572",
  "R4573" : "G4573",
  "R4574" : "G4574",
  "R4575" : "G4575",
  "R4580" : "G4580",
  "R4581" : "G4581",
  "R4582" : "G4582",
  "R4583" : "G4583",
  "R4584" : "G4584",
  "R4585" : "G4585",
  "R4586" : "G4586",
  "R4587" : "G4587",
  "R4588" : "G4588",
  "R4589" : "G4589",
  "R4590" : "G4590",
  "R4591" : "G4591",
  "R4592" : "G4592",
  "R4593" : "G4593",
  "R4594" : "G4594",
  "R4595" : "G4595",
  "R4650" : "G4650",
  "R5" : "G5",
  "R50" : "G50",
  "R5004" : "G5004",
  "R5005" : "G5005",
  "R5006" : "G5006",
  "R5013" : "G5013",
  "R5014" : "G5014",
  "R5015" : "G5015",
  "R5016" : "G5016",
  "R5017" : "G5017",
  "R5079" : "G5079",
  "R5080" : "G5080",
  "R5081" : "G5081",
  "R5082" : "G5082",
  "R5083" : "G5083",
  "R5084" : "G5084",
  "R5087" : "G5087",
  "R5088" : "G5088",
  "R5089" : "G5089",
  "R5090" : "G5090",
  "R51" : "G51",
  "R5100" : "G5100",
  "R5101" : "G5101",
  "R5102" : "G5102",
  "R5103" : "G5103",
  "R5104" : "G5104",
  "R5105" : "G5105",
  "R5106" : "G5106",
  "R5107" : "G5107",
  "R5108" : "G5108",
  "R5109" : "G5109",
  "R5110" : "G5110",
  "R5111" : "G5111",
  "R5112" : "G5112",
  "R5113" : "G5113",
  "R5114" : "G5114",
  "R5115" : "G5115",
  "R5116" : "G5116",
  "R5117" : "G5117",
  "R5118" : "G5118",
  "R516" : "G516",
  "R517" : "G517",
  "R518" : "G518",
  "R519" : "G519",
  "R52" : "G52",
  "R520" : "G520",
  "R5200" : "G5200",
  "R5203" : "G5203",
  "R5204" : "G5204",
  "R5205" : "G5205",
  "R5206" : "G5206",
  "R5207" : "G5207",
  "R5208" : "G5208",
  "R5209" : "G5209",
  "R5210" : "G5210",
  "R5211" : "G5211",
  "R5212" : "G5212",
  "R5213" : "G5213",
  "R5214" : "G5214",
  "R5215" : "G5215",
  "R5216" : "G5216",
  "R5217" : "G5217",
  "R522" : "G522",
  "R5220" : "G5220",
  "R5221" : "G5221",
  "R5222" : "G5222",
  "R5223" : "G5223",
  "R5224" : "G5224",
  "R5225" : "G5225",
  "R5226" : "G5226",
  "R5227" : "G5227",
  "R5228" : "G5228",
  "R5229" : "G5229",
  "R5230" : "G5230",
  "R5231" : "G5231",
  "R5232" : "G5232",
  "R5233" : "G5233",
  "R5234" : "G5234",
  "R5235" : "G5235",
  "R5236" : "G5236",
  "R5237" : "G5237",
  "R526" : "G526",
  "R527" : "G527",
  "R528" : "G528",
  "R529" : "G529",
  "R530" : "G530",
  "R531" : "G531",
  "R532" : "G532",
  "R5325" : "G5325",
  "R533" : "G533",
  "R534" : "G534",
  "R5343" : "G5343",
  "R535" : "G535",
  "R536" : "G536",
  "R537" : "G537",
  "R538" : "G538",
  "R5381" : "G5381",
  "R5383" : "G5383",
  "R5384" : "G5384",
  "R5387" : "G5387",
  "R539" : "G539",
  "R5390" : "G5390",
  "R5392" : "G5392",
  "R5393" : "G5393",
  "R5394" : "G5394",
  "R5396" : "G5396",
  "R5397" : "G5397",
  "R5398" : "G5398",
  "R540" : "G540",
  "R541" : "G541",
  "R542" : "G542",
  "R543" : "G543",
  "R544" : "G544",
  "R547" : "G547",
  "R548" : "G548",
  "R549" : "G549",
  "R55" : "G55",
  "R551" : "G551",
  "R552" : "G552",
  "R5521" : "G5521",
  "R5523" : "G5523",
  "R5524" : "G5524",
  "R5525" : "G5525",
  "R5526" : "G5526",
  "R5527" : "G5527",
  "R5528" : "G5528",
  "R5529" : "G5529",
  "R553" : "G553",
  "R5530" : "G5530",
  "R5531" : "G5531",
  "R5532" : "G5532",
  "R5533" : "G5533",
  "R5534" : "G5534",
  "R5535" : "G5535",
  "R5536" : "G5536",
  "R5537" : "G5537",
  "R5538" : "G5538",
  "R5539" : "G5539",
  "R554" : "G554",
  "R5540" : "G5540",
  "R5541" : "G5541",
  "R5542" : "G5542",
  "R5543" : "G5543",
  "R5544" : "G5544",
  "R555" : "G555",
  "R556" : "G556",
  "R557" : "G557",
  "R558" : "G558",
  "R559" : "G559",
  "R56" : "G56",
  "R560" : "G560",
  "R5600" : "G5600",
  "R5601" : "G5601",
  "R5602" : "G5602",
  "R5603" : "G5603",
  "R5604" : "G5604",
  "R5605" : "G5605",
  "R5606" : "G5606",
  "R5608" : "G5608",
  "R5609" : "G5609",
  "R561" : "G561",
  "R5610" : "G5610",
  "R5611" : "G5611",
  "R5612" : "G5612",
  "R5613" : "G5613",
  "R5614" : "G5614",
  "R5615" : "G5615",
  "R5616" : "G5616",
  "R5617" : "G5617",
  "R5618" : "G5618",
  "R5619" : "G5619",
  "R562" : "G562",
  "R5620" : "G5620",
  "R5621" : "G5621",
  "R5623" : "G5623",
  "R5624" : "G5624",
  "R5625" : "G5625",
  "R5626" : "G5626",
  "R5627" : "G5627",
  "R5628" : "G5628",
  "R563" : "G563",
  "R5630" : "G5630",
  "R5631" : "G5631",
  "R5632" : "G5632",
  "R5633" : "G5633",
  "R5634" : "G5634",
  "R5635" : "G5635",
  "R5636" : "G5636",
  "R5637" : "G5637",
  "R5638" : "G5638",
  "R5639" : "G5639",
  "R564" : "G564",
  "R5641" : "G5641",
  "R5642" : "G5642",
  "R5643" : "G5643",
  "R5644" : "G5644",
  "R5645" : "G5645",
  "R5646" : "G5646",
  "R5647" : "G5647",
  "R5648" : "G5648",
  "R5649" : "G5649",
  "R565" : "G565",
  "R5650" : "G5650",
  "R5651" : "G5651",
  "R5652" : "G5652",
  "R5653" : "G5653",
  "R566" : "G566",
  "R567" : "G567",
  "R568" : "G568",
  "R569" : "G569",
  "R570" : "G570",
  "R5700" : "G5700",
  "R5701" : "G5701",
  "R5702" : "G5702",
  "R5703" : "G5703",
  "R5704" : "G5704",
  "R5705" : "G5705",
  "R5706" : "G5706",
  "R5707" : "G5707",
  "R5708" : "G5708",
  "R5709" : "G5709",
  "R571" : "G571",
  "R5712" : "G5712",
  "R5713" : "G5713",
  "R5714" : "G5714",
  "R572" : "G572",
  "R5720" : "G5720",
  "R5721" : "G5721",
  "R5722" : "G5722",
  "R5723" : "G5723",
  "R5725" : "G5725",
  "R5726" : "G5726",
  "R5727" : "G5727",
  "R5728" : "G5728",
  "R5729" : "G5729",
  "R573" : "G573",
  "R5730" : "G5730",
  "R5731" : "G5731",
  "R5732" : "G5732",
  "R5733" : "G5733",
  "R5734" : "G5734",
  "R5735" : "G5735",
  "R5736" : "G5736",
  "R5737" : "G5737",
  "R5738" : "G5738",
  "R5739" : "G5739",
  "R574" : "G574",
  "R5740" : "G5740",
  "R5741" : "G5741",
  "R5742" : "G5742",
  "R5743" : "G5743",
  "R5744" : "G5744",
  "R5745" : "G5745",
  "R575" : "G575",
  "R576" : "G576",
  "R577" : "G577",
  "R578" : "G578",
  "R579" : "G579",
  "R580" : "G580",
  "R5800" : "G5800",
  "R5801" : "G5801",
  "R5802" : "G5802",
  "R5803" : "G5803",
  "R5804" : "G5804",
  "R5805" : "G5805",
  "R5806" : "G5806",
  "R5807" : "G5807",
  "R5808" : "G5808",
  "R5809" : "G5809",
  "R581" : "G581",
  "R5810" : "G5810",
  "R5811" : "G5811",
  "R5812" : "G5812",
  "R5813" : "G5813",
  "R5814" : "G5814",
  "R5815" : "G5815",
  "R5816" : "G5816",
  "R5817" : "G5817",
  "R5818" : "G5818",
  "R5819" : "G5819",
  "R582" : "G582",
  "R5820" : "G5820",
  "R5821" : "G5821",
  "R5822" : "G5822",
  "R5823" : "G5823",
  "R5824" : "G5824",
  "R5825" : "G5825",
  "R5826" : "G5826",
  "R5827" : "G5827",
  "R5828" : "G5828",
  "R5829" : "G5829",
  "R583" : "G583",
  "R5838" : "G5838",
  "R5839" : "G5839",
  "R584" : "G584",
  "R5840" : "G5840",
  "R5841" : "G5841",
  "R5842" : "G5842",
  "R5843" : "G5843",
  "R5844" : "G5844",
  "R5845" : "G5845",
  "R5846" : "G5846",
  "R5847" : "G5847",
  "R5848" : "G5848",
  "R5849" : "G5849",
  "R585" : "G585",
  "R5850" : "G5850",
  "R5851" : "G5851",
  "R5852" : "G5852",
  "R5853" : "G5853",
  "R5854" : "G5854",
  "R5855" : "G5855",
  "R5856" : "G5856",
  "R5857" : "G5857",
  "R5858" : "G5858",
  "R5859" : "G5859",
  "R5860" : "G5860",
  "R5861" : "G5861",
  "R5862" : "G5862",
  "R6" : "G6",
  "R60" : "G60",
  "R6000" : "G6000",
  "R601" : "G601",
  "R6010" : "G6010",
  "R6011" : "G6011",
  "R6012" : "G6012",
  "R6013" : "G6013",
  "R6014" : "G6014",
  "R6015" : "G6015",
  "R6016" : "G6016",
  "R602" : "G602",
  "R603" : "G603",
  "R604" : "G604",
  "R605" : "G605",
  "R606" : "G606",
  "R607" : "G607",
  "R6072" : "G6072",
  "R6073" : "G6073",
  "R6074" : "G6074",
  "R6075" : "G6075",
  "R6079" : "G6079",
  "R608" : "G608",
  "R6081" : "G6081",
  "R6083" : "G6083",
  "R609" : "G609",
  "R61" : "G61",
  "R610" : "G610",
  "R6100" : "G6100",
  "R6101" : "G6101",
  "R6102" : "G6102",
  "R611" : "G611",
  "R612" : "G612",
  "R6126" : "G6126",
  "R6127" : "G6127",
  "R6128" : "G6128",
  "R613" : "G613",
  "R6133" : "G6133",
  "R6134" : "G6134",
  "R6135" : "G6135",
  "R6136" : "G6136",
  "R6137" : "G6137",
  "R6138" : "G6138",
  "R6139" : "G6139",
  "R614" : "G614",
  "R6140" : "G6140",
  "R6141" : "G6141",
  "R6142" : "G6142",
  "R6143" : "G6143",
  "R6144" : "G6144",
  "R6145" : "G6145",
  "R6146" : "G6146",
  "R6147" : "G6147",
  "R6148" : "G6148",
  "R615" : "G615",
  "R616" : "G616",
  "R617" : "G617",
  "R618" : "G618",
  "R619" : "G619",
  "R62" : "G62",
  "R620" : "G620",
  "R621" : "G621",
  "R6219" : "G6219",
  "R622" : "G622",
  "R623" : "G623",
  "R6236" : "G6236",
  "R6237" : "G6237",
  "R6238" : "G6238",
  "R6239" : "G6239",
  "R624" : "G624",
  "R6240" : "G6240",
  "R6247" : "G6247",
  "R6248" : "G6248",
  "R6249" : "G6249",
  "R625" : "G625",
  "R6250" : "G6250",
  "R6251" : "G6251",
  "R6252" : "G6252",
  "R6253" : "G6253",
  "R6254" : "G6254",
  "R6255" : "G6255",
  "R626" : "G626",
  "R627" : "G627",
  "R628" : "G628",
  "R629" : "G629",
  "R630" : "G630",
  "R6300" : "G6300",
  "R6301" : "G6301",
  "R6302" : "G6302",
  "R6303" : "G6303",
  "R6304" : "G6304",
  "R6305" : "G6305",
  "R6306" : "G6306",
  "R6307" : "G6307",
  "R6308" : "G6308",
  "R6309" : "G6309",
  "R631" : "G631",
  "R6310" : "G6310",
  "R6311" : "G6311",
  "R6312" : "G6312",
  "R6313" : "G6313",
  "R632" : "G632",
  "R633" : "G633",
  "R6331" : "G6331",
  "R6332" : "G6332",
  "R6333" : "G6333",
  "R6334" : "G6334",
  "R6335" : "G6335",
  "R6336" : "G6336",
  "R6337" : "G6337",
  "R6338" : "G6338",
  "R6339" : "G6339",
  "R634" : "G634",
  "R6340" : "G6340",
  "R6341" : "G6341",
  "R6342" : "G6342",
  "R6345" : "G6345",
  "R6346" : "G6346",
  "R635" : "G635",
  "R636" : "G636",
  "R637" : "G637",
  "R638" : "G638",
  "R639" : "G639",
  "R640" : "G640",
  "R6400" : "G6400",
  "R6401" : "G6401",
  "R6402" : "G6402",
  "R6403" : "G6403",
  "R6404" : "G6404",
  "R6405" : "G6405",
  "R6406" : "G6406",
  "R6407" : "G6407",
  "R6408" : "G6408",
  "R6409" : "G6409",
  "R641" : "G641",
  "R6410" : "G6410",
  "R6411" : "G6411",
  "R6412" : "G6412",
  "R6413" : "G6413",
  "R6414" : "G6414",
  "R6415" : "G6415",
  "R6416" : "G6416",
  "R6417" : "G6417",
  "R6418" : "G6418",
  "R6419" : "G6419",
  "R642" : "G642",
  "R6420" : "G6420",
  "R6421" : "G6421",
  "R6422" : "G6422",
  "R6423" : "G6423",
  "R6424" : "G6424",
  "R6425" : "G6425",
  "R6426" : "G6426",
  "R6427" : "G6427",
  "R6428" : "G6428",
  "R6429" : "G6429",
  "R643" : "G643",
  "R6439" : "G6439",
  "R644" : "G644",
  "R6440" : "G6440",
  "R6441" : "G6441",
  "R6442" : "G6442",
  "R6443" : "G6443",
  "R6444" : "G6444",
  "R6445" : "G6445",
  "R6446" : "G6446",
  "R6449" : "G6449",
  "R645" : "G645",
  "R6452" : "G6452",
  "R6455" : "G6455",
  "R6458" : "G6458",
  "R6459" : "G6459",
  "R646" : "G646",
  "R6460" : "G6460",
  "R647" : "G647",
  "R648" : "G648",
  "R649" : "G649",
  "R650" : "G650",
  "R651" : "G651",
  "R652" : "G652",
  "R6526" : "G6526",
  "R653" : "G653",
  "R654" : "G654",
  "R655" : "G655",
  "R658" : "G658",
  "R659" : "G659",
  "R66" : "G66",
  "R67" : "G67",
  "R7" : "G7",
  "R70" : "G70",
  "R702" : "G702",
  "R703" : "G703",
  "R7031" : "G7031",
  "R7032" : "G7032",
  "R7033" : "G7033",
  "R7034" : "G7034",
  "R704" : "G704",
  "R7055" : "G7055",
  "R7056" : "G7056",
  "R7057" : "G7057",
  "R7058" : "G7058",
  "R7059" : "G7059",
  "R7060" : "G7060",
  "R7061" : "G7061",
  "R71" : "G71",
  "R7100" : "G7100",
  "R7101" : "G7101",
  "R7102" : "G7102",
  "R7103" : "G7103",
  "R7106" : "G7106",
  "R7107" : "G7107",
  "R7108" : "G7108",
  "R7109" : "G7109",
  "R7110" : "G7110",
  "R7111" : "G7111",
  "R7112" : "G7112",
  "R7113" : "G7113",
  "R7114" : "G7114",
  "R7115" : "G7115",
  "R7116" : "G7116",
  "R7117" : "G7117",
  "R7118" : "G7118",
  "R7119" : "G7119",
  "R712" : "G712",
  "R7120" : "G7120",
  "R7121" : "G7121",
  "R7122" : "G7122",
  "R7123" : "G7123",
  "R7124" : "G7124",
  "R7125" : "G7125",
  "R7126" : "G7126",
  "R713" : "G713",
  "R715" : "G715",
  "R716" : "G716",
  "R717" : "G717",
  "R719" : "G719",
  "R72" : "G72",
  "R7200" : "G7200",
  "R7201" : "G7201",
  "R7202" : "G7202",
  "R7203" : "G7203",
  "R7204" : "G7204",
  "R7205" : "G7205",
  "R7206" : "G7206",
  "R7207" : "G7207",
  "R7213" : "G7213",
  "R7214" : "G7214",
  "R7215" : "G7215",
  "R7216" : "G7216",
  "R7217" : "G7217",
  "R7218" : "G7218",
  "R7219" : "G7219",
  "R7220" : "G7220",
  "R7221" : "G7221",
  "R7222" : "G7222",
  "R7223" : "G7223",
  "R7224" : "G7224",
  "R7225" : "G7225",
  "R7226" : "G7226",
  "R7227" : "G7227",
  "R7228" : "G7228",
  "R7229" : "G7229",
  "R73" : "G73",
  "R731" : "G731",
  "R732" : "G732",
  "R733" : "G733",
  "R734" : "G734",
  "R735" : "G735",
  "R736" : "G736",
  "R737" : "G737",
  "R738" : "G738",
  "R739" : "G739",
  "R74" : "G74",
  "R740" : "G740",
  "R741" : "G741",
  "R742" : "G742",
  "R75" : "G75",
  "R752" : "G752",
  "R753" : "G753",
  "R76" : "G76",
  "R77" : "G77",
  "R778" : "G778",
  "R78" : "G78",
  "R780" : "G780",
  "R781" : "G781",
  "R783" : "G783",
  "R79" : "G79",
  "R799" : "G799",
  "R80" : "G80",
  "R800" : "G800",
  "R8000" : "G8000",
  "R8001" : "G8001",
  "R8002" : "G8002",
  "R8003" : "G8003",
  "R8004" : "G8004",
  "R8005" : "G8005",
  "R8006" : "G8006",
  "R8007" : "G8007",
  "R8008" : "G8008",
  "R8009" : "G8009",
  "R8010" : "G8010",
  "R8011" : "G8011",
  "R8012" : "G8012",
  "R8013" : "G8013",
  "R8014" : "G8014",
  "R8015" : "G8015",
  "R802" : "G802",
  "R8020" : "G8020",
  "R8021" : "G8021",
  "R8022" : "G8022",
  "R8023" : "G8023",
  "R8024" : "G8024",
  "R8025" : "G8025",
  "R8026" : "G8026",
  "R8027" : "G8027",
  "R8028" : "G8028",
  "R8029" : "G8029",
  "R803" : "G803",
  "R8030" : "G8030",
  "R8031" : "G8031",
  "R8032" : "G8032",
  "R8033" : "G8033",
  "R8034" : "G8034",
  "R8035" : "G8035",
  "R8036" : "G8036",
  "R8037" : "G8037",
  "R806" : "G806",
  "R8061" : "G8061",
  "R807" : "G807",
  "R808" : "G808",
  "R81" : "G81",
  "R8138" : "G8138",
  "R8139" : "G8139",
  "R8140" : "G8140",
  "R8141" : "G8141",
  "R8142" : "G8142",
  "R8143" : "G8143",
  "R8144" : "G8144",
  "R8145" : "G8145",
  "R8146" : "G8146",
  "R8147" : "G8147",
  "R8148" : "G8148",
  "R8149" : "G8149",
  "R8150" : "G8150",
  "R8151" : "G8151",
  "R8152" : "G8152",
  "R8153" : "G8153",
  "R8154" : "G8154",
  "R8155" : "G8155",
  "R8156" : "G8156",
  "R8157" : "G8157",
  "R8158" : "G8158",
  "R8159" : "G8159",
  "R8160" : "G8160",
  "R8161" : "G8161",
  "R8162" : "G8162",
  "R8163" : "G8163",
  "R8164" : "G8164",
  "R8165" : "G8165",
  "R8166" : "G8166",
  "R8167" : "G8167",
  "R8168" : "G8168",
  "R8169" : "G8169",
  "R8170" : "G8170",
  "R8171" : "G8171",
  "R8172" : "G8172",
  "R8173" : "G8173",
  "R8174" : "G8174",
  "R8175" : "G8175",
  "R8176" : "G8176",
  "R8177" : "G8177",
  "R8178" : "G8178",
  "R8179" : "G8179",
  "R8180" : "G8180",
  "R8181" : "G8181",
  "R8182" : "G8182",
  "R8183" : "G8183",
  "R8184" : "G8184",
  "R8185" : "G8185",
  "R8186" : "G8186",
  "R8187" : "G8187",
  "R8188" : "G8188",
  "R8189" : "G8189",
  "R8190" : "G8190",
  "R8191" : "G8191",
  "R8192" : "G8192",
  "R8193" : "G8193",
  "R8194" : "G8194",
  "R8195" : "G8195",
  "R8196" : "G8196",
  "R8197" : "G8197",
  "R8198" : "G8198",
  "R8199" : "G8199",
  "R82" : "G82",
  "R8200" : "G8200",
  "R8201" : "G8201",
  "R8202" : "G8202",
  "R8203" : "G8203",
  "R8204" : "G8204",
  "R8205" : "G8205",
  "R8206" : "G8206",
  "R8207" : "G8207",
  "R8208" : "G8208",
  "R8209" : "G8209",
  "R8211" : "G8211",
  "R8212" : "G8212",
  "R8213" : "G8213",
  "R8214" : "G8214",
  "R8215" : "G8215",
  "R8218" : "G8218",
  "R8219" : "G8219",
  "R8220" : "G8220",
  "R8221" : "G8221",
  "R8222" : "G8222",
  "R8223" : "G8223",
  "R8224" : "G8224",
  "R8225" : "G8225",
  "R8226" : "G8226",
  "R8227" : "G8227",
  "R8228" : "G8228",
  "R8229" : "G8229",
  "R8230" : "G8230",
  "R8231" : "G8231",
  "R8232" : "G8232",
  "R8233" : "G8233",
  "R8234" : "G8234",
  "R8235" : "G8235",
  "R8236" : "G8236",
  "R8237" : "G8237",
  "R8238" : "G8238",
  "R8239" : "G8239",
  "R8240" : "G8240",
  "R8241" : "G8241",
  "R8243" : "G8243",
  "R8244" : "G8244",
  "R8245" : "G8245",
  "R8247" : "G8247",
  "R8248" : "G8248",
  "R8249" : "G8249",
  "R8257" : "G8257",
  "R8262" : "G8262",
  "R83" : "G83",
  "R8300" : "G8300",
  "R8301" : "G8301",
  "R8302" : "G8302",
  "R8303" : "G8303",
  "R8304" : "G8304",
  "R8305" : "G8305",
  "R8306" : "G8306",
  "R8307" : "G8307",
  "R8308" : "G8308",
  "R8309" : "G8309",
  "R8310" : "G8310",
  "R8311" : "G8311",
  "R8312" : "G8312",
  "R8313" : "G8313",
  "R8314" : "G8314",
  "R8315" : "G8315",
  "R8316" : "G8316",
  "R8317" : "G8317",
  "R8318" : "G8318",
  "R8319" : "G8319",
  "R8320" : "G8320",
  "R8321" : "G8321",
  "R8322" : "G8322",
  "R8323" : "G8323",
  "R8324" : "G8324",
  "R8361" : "G8361",
  "R8365" : "G8365",
  "R8366" : "G8366",
  "R8367" : "G8367",
  "R8368" : "G8368",
  "R8369" : "G8369",
  "R8370" : "G8370",
  "R8371" : "G8371",
  "R84" : "G84",
  "R8400" : "G8400",
  "R8401" : "G8401",
  "R8402" : "G8402",
  "R8403" : "G8403",
  "R8404" : "G8404",
  "R8405" : "G8405",
  "R8406" : "G8406",
  "R8407" : "G8407",
  "R8408" : "G8408",
  "R8409" : "G8409",
  "R8410" : "G8410",
  "R8411" : "G8411",
  "R8412" : "G8412",
  "R8413" : "G8413",
  "R8414" : "G8414",
  "R8415" : "G8415",
  "R8416" : "G8416",
  "R8417" : "G8417",
  "R8418" : "G8418",
  "R8419" : "G8419",
  "R8449" : "G8449",
  "R8450" : "G8450",
  "R8451" : "G8451",
  "R8452" : "G8452",
  "R8453" : "G8453",
  "R8454" : "G8454",
  "R8455" : "G8455",
  "R8456" : "G8456",
  "R8457" : "G8457",
  "R8458" : "G8458",
  "R8459" : "G8459",
  "R8460" : "G8460",
  "R8461" : "G8461",
  "R8462" : "G8462",
  "R8463" : "G8463",
  "R8464" : "G8464",
  "R8465" : "G8465",
  "R8466" : "G8466",
  "R8467" : "G8467",
  "R8468" : "G8468",
  "R8469" : "G8469",
  "R8470" : "G8470",
  "R8471" : "G8471",
  "R8472" : "G8472",
  "R8473" : "G8473",
  "R8474" : "G8474",
  "R8475" : "G8475",
  "R8476" : "G8476",
  "R8477" : "G8477",
  "R8478" : "G8478",
  "R8479" : "G8479",
  "R8480" : "G8480",
  "R8481" : "G8481",
  "R8482" : "G8482",
  "R8483" : "G8483",
  "R8484" : "G8484",
  "R8485" : "G8485",
  "R8486" : "G8486",
  "R8487" : "G8487",
  "R8488" : "G8488",
  "R8489" : "G8489",
  "R8490" : "G8490",
  "R8491" : "G8491",
  "R8492" : "G8492",
  "R8493" : "G8493",
  "R8494" : "G8494",
  "R8495" : "G8495",
  "R8496" : "G8496",
  "R8497" : "G8497",
  "R8498" : "G8498",
  "R8499" : "G8499",
  "R85" : "G85",
  "R8500" : "G8500",
  "R86" : "G86",
  "R8952" : "G8952",
  "R8953" : "G8953",
  "R8954" : "G8954",
  "R8955" : "G8955",
  "R8956" : "G8956",
  "R8957" : "G8957",
  "R8958" : "G8958",
  "R8959" : "G8959",
  "R8960" : "G8960",
  "R8961" : "G8961",
  "R8962" : "G8962",
  "R8963" : "G8963",
  "R8964" : "G8964",
  "R8965" : "G8965",
  "R8966" : "G8966",
  "R8967" : "G8967",
  "R8968" : "G8968",
  "R8969" : "G8969",
  "R8970" : "G8970",
  "R8971" : "G8971",
  "R8972" : "G8972",
  "R8973" : "G8973",
  "R8974" : "G8974",
  "R8975" : "G8975",
  "R8976" : "G8976",
  "R8977" : "G8977",
  "R8978" : "G8978",
  "R8979" : "G8979",
  "R8980" : "G8980",
  "R8981" : "G8981",
  "R90" : "G90",
  "R908" : "G908",
  "R91" : "G91",
  "R910" : "G910",
  "R911" : "G911",
  "R912" : "G912",
  "R913" : "G913",
  "R9133" : "G9133",
  "R914" : "G914",
  "R915" : "G915",
  "R916" : "G916",
  "R917" : "G917",
  "R918" : "G918",
  "R919" : "G919",
  "R92" : "G92",
  "R920" : "G920",
  "R921" : "G921",
  "R922" : "G922",
  "R923" : "G923",
  "R924" : "G924",
  "R95" : "G95",
  "R9717" : "G9717",
  "R9718" : "G9718",
  "R9719" : "G9719",
  "R9720" : "G9720",
  "R9721" : "G9721",
  "R9722" : "G9722",
  "R9723" : "G9723",
  "R9724" : "G9724",
  "R9725" : "G9725",
  "R9726" : "G9726",
  "R9727" : "G9727",
  "R9728" : "G9728",
  "R9729" : "G9729",
  "R9730" : "G9730",
  "R9731" : "G9731",
  "R9732" : "G9732",
  "R9733" : "G9733",
  "R9735" : "G9735",
  "R9736" : "G9736",
  "R9740" : "G9740",
  "R9779" : "O9779",
  "R9789" : "O9789",
  "R9790" : "O9790",
  "R9803" : "G9803",
  "R9806" : "G9806",
  "R9827" : "G9827",
  "R9828" : "G9828",
  "R9829" : "G9829",
  "R9830" : "G9830",
  "R9831" : "G9831",
  "R9832" : "G9832",
  "R9833" : "G9833",
  "R9834" : "G9834",
  "R9835" : "G9835",
  "R9836" : "G9836",
  "R9837" : "G9837",
  "R9838" : "G9838",
  "R9839" : "G9839",
  "R9840" : "G9840",
  "R9841" : "G9841",
  "R9842" : "G9842",
  "R9843" : "G9843",
  "R9844" : "G9844",
  "R9845" : "G9845",
  "R9846" : "G9846",
  "R9847" : "G9847",
  "R9848" : "G9848",
  "R9849" : "G9849",
  "R9850" : "G9850",
  "R9851" : "G9851",
  "R9852" : "G9852",
  "R9853" : "G9853",
  "R9854" : "G9854",
  "R9855" : "G9855",
  "R9856" : "G9856",
  "R9857" : "G9857",
  "R9858" : "G9858",
  "R9859" : "G9859",
  "R9860" : "G9860",
  "R9861" : "G9861",
  "R9862" : "G9862",
  "R9863" : "G9863",
  "R9864" : "G9864",
  "R9865" : "G9865",
  "R9866" : "G9866",
  "R9867" : "G9867",
  "R9868" : "G9868",
  "R9869" : "G9869",
  "R9870" : "G9870",
  "R9871" : "G9871",
  "R9872" : "G9872",
  "R9873" : "G9873",
  "R9878" : "G9878",
  "R9882" : "G9882"
}
